import React, { useEffect, useState } from 'react';
import { FlameIcon, ClockIcon } from './icons';
interface UrgencyBarProps {
  formattedTime?: string;
}
function getTimeLeft(target: number) {
  const diff = Math.max(0, target - Date.now());
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor(diff / (1000 * 60 * 60) % 24);
  const minutes = Math.floor(diff / (1000 * 60) % 60);
  const seconds = Math.floor(diff / 1000 % 60);
  return {
    days,
    hours,
    minutes,
    seconds
  };
}
export const UrgencyBar: React.FC<UrgencyBarProps> = () => {
  const [target] = useState(() => Date.now() + 3 * 24 * 60 * 60 * 1000);
  const [time, setTime] = useState(() => getTimeLeft(target));
  useEffect(() => {
    const id = setInterval(() => setTime(getTimeLeft(target)), 1000);
    return () => clearInterval(id);
  }, [target]);
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <div className="sticky top-0 z-50 w-full bg-forest text-cream py-2 px-4 shadow-md text-xs sm:text-sm" data-id="element-273">
      <div className="max-w-6xl mx-auto flex items-center justify-center sm:justify-between gap-4" data-id="element-274">
        <div className="flex items-center gap-2 font-medium" data-id="element-275">
          <FlameIcon className="w-4 h-4 text-gold shrink-0" data-id="element-276" />
          <span data-id="element-277">
            <strong className="text-gold font-semibold tracking-wide" data-id="element-278">
              LIMITED TIME:
            </strong>{' '}
            <span className="hidden sm:inline" data-id="element-279">$557 bundle for </span>$37
          </span>
        </div>

        <div className="flex items-center gap-2 sm:gap-3 shrink-0" data-id="element-280">
          <div className="hidden sm:flex items-center gap-1.5 text-[10px] uppercase tracking-[0.15em] text-cream/70 font-semibold" data-id="element-281">
            <ClockIcon className="w-3 h-3 text-gold" data-id="element-282" />
            Expires in
          </div>

          <div className="flex items-center gap-1 font-mono" data-id="element-283">
            <TimeBlock value={pad(time.days)} label="D" data-id="element-284" />
            <span className="text-gold/60 font-bold" data-id="element-285">:</span>
            <TimeBlock value={pad(time.hours)} label="H" data-id="element-286" />
            <span className="text-gold/60 font-bold" data-id="element-287">:</span>
            <TimeBlock value={pad(time.minutes)} label="M" data-id="element-288" />
            <span className="text-gold/60 font-bold" data-id="element-289">:</span>
            <TimeBlock value={pad(time.seconds)} label="S" data-id="element-290" />
          </div>

          <button className="hidden sm:block bg-gold hover:bg-gold-dark text-forest-dark font-bold text-[11px] px-3 py-1 rounded transition-colors uppercase tracking-wider" data-id="element-291">
            Claim
          </button>
        </div>
      </div>
    </div>;
};
const TimeBlock: React.FC<{
  value: string;
  label: string;
}> = ({
  value,
  label
}) => <div className="flex items-baseline gap-0.5 bg-forest-dark px-1.5 py-0.5 rounded border border-gold/20" data-id="element-292">
    <span className="font-bold text-gold text-xs sm:text-sm tracking-wider tabular-nums" data-id="element-293">
      {value}
    </span>
    <span className="text-[8px] sm:text-[9px] uppercase text-gold/60 font-semibold" data-id="element-294">
      {label}
    </span>
  </div>;